const data = {
  id: 1,
  title: 'Listen and choose the correct sound.',
  subTitle: 'Nghe và chọn âm xuất hiện trong từ.',
  audioUrl: 'https://cloud.softech.cloud/storage/Data/Sentences/ce90e45f-5201-410f-b5db-2569f63c93cb.mp3',
  answers: [
    { id: 1, answer: 'c', isCorrect: true },
    { id: 2, answer: 'g', isCorrect: false },
    { id: 3, answer: 'w', isCorrect: false },
  ],
  settings: {
    answers: {
      direction: 'horizontal',
      bulletType: 'none',
      // bulletType: 'character',
      // bulletType: 'number',
    },
  },
};

export default data;
